/**
 * What each order status means, in the words a clinic would use.
 *
 * The status is core's `metadata.internal_order_status`, roughly in the order an
 * order moves through them. Read from core-prod (2026-10-26): routing sets
 * ROUTING_COMPLETED when a doctor AND a pharmacy are assigned and ROUTING_FAILED
 * when either is missing; the pharmacy flow maps COMPLETE_FILLED/LABEL_CREATED to
 * AT_PHARMACY, DELIVERED to COMPLETED, and a pharmacy cancel or address problem
 * to ISSUE_AT_PHARMACY. COMPLETED_LOCAL is this app's, not core's. The last
 * group only exists on legacy MDExam orders.
 */
export const ORDER_STATUS_INFO = {
  PAYMENT_SUCCEEDED: 'Paid, but not yet routed to a doctor and pharmacy.',
  WAITING_APPOINTMENT: "The program needs an appointment first. Waiting for the patient's appointment before the order goes to a doctor.",
  ROUTING_COMPLETED: "Assigned a doctor and a pharmacy. It is in the doctor's queue to review and write the prescription.",
  ROUTING_FAILED: 'Could not be assigned a doctor or a pharmacy, so no doctor can see it. Someone needs to fix it and re-route.',
  SCRIPT_WRITTEN: 'The doctor approved it and wrote the prescription. Waiting for the pharmacy to pick it up.',
  COMPLETED_LOCAL: 'Prescription written for a program filled locally (phentermine, management). Nothing ships from us, so it is done.',
  AT_PHARMACY: 'The pharmacy has it: filled or labelled, not shipped yet.',
  ISSUE_AT_PHARMACY: 'The pharmacy cancelled it or reported a problem, such as the address. Needs a look.',
  IN_SHIPPING: 'Shipped and with the carrier.',
  ISSUE_IN_SHIPPING: 'The carrier reported a problem with the delivery.',
  COMPLETED: 'Delivered to the patient.',
  WAITING_REFILL: 'A refill or later shipment of a bundle that is not due yet. A planned hold, not a stuck order.',
  PENDING_CANCELLATION: 'A cancellation was requested and is not final yet.',
  CANCELLED: 'Cancelled. It will not be filled.',
  CANCELLED_REORDER: 'Cancelled and set aside to be placed again as a new order.',
  NURSE_QUALIFIED: 'Legacy MDExam: passed nurse screening, waiting for a doctor.',
  ROUTED_TO_DOCTOR: "Legacy MDExam: in a doctor's queue to review.",
  ROUTED_TO_PHARMACY: 'Legacy MDExam: approved and sent to the pharmacy.',
  FILL_CREATED: 'Legacy MDExam: the pharmacy started filling it.',
  LABEL_CREATED: 'Legacy MDExam: shipping label printed, about to ship.',
  UNKNOWN: 'The order has no status recorded.',
}

export const orderStatusInfo = status => ORDER_STATUS_INFO[String(status || '').toUpperCase()] || null
